import { render, staticRenderFns } from "./FontsWrapper.vue?vue&type=template&id=3f746f3b&"
import script from "./FontsWrapper.vue?vue&type=script&lang=js&"
export * from "./FontsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f746f3b')) {
      api.createRecord('3f746f3b', component.options)
    } else {
      api.reload('3f746f3b', component.options)
    }
    module.hot.accept("./FontsWrapper.vue?vue&type=template&id=3f746f3b&", function () {
      api.rerender('3f746f3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/FontsWrapper.vue"
export default component.exports